export enum OverlayTypology {
    ENABLE = 'IsEnabled',
    ADD_TO_LIST = 'IsAddedToList',
    DEFAULT = 'IsDefault'
}
